import { parseHtmlString } from 'ingestion/nodeCreationHelpers'
import { IM360Parser } from '../../IM360Parser'
import { QuestionType } from 'shared/types/ingestion'

export function parseGoTogether({
  title,
  statement,
  studentResponse,
}: {
  title?: string
  statement?: string
  studentResponse?: string
}) {
  if (!statement || !isGoTogether(statement)) return
  const asHtml = parseHtmlString(statement)
  const answers = getAnswers(asHtml)
  if (!answers) return
  return [
    IM360Parser.getInstance().createMultiAnswerQuestion({
      title,
      answers,
      description: asHtml.body.innerHTML,
      teacherNote: studentResponse,
      overrides: { type: QuestionType.MultipleSelect },
      showWork: true,
    }),
  ]
}

const goTogetherRegex = /Which [1-9] go together\?/gm

function isGoTogether(description: string) {
  if (!goTogetherRegex.test(description)) return false
  const asHtml = parseHtmlString(description)

  return !!(
    asHtml.getElementsByClassName('imgrid').length ||
    asHtml.getElementsByTagName('ol').length
  )
}

function getAnswers(asHtml: Document) {
  const answers = getTableAnswers(asHtml) ?? getGridAnswers(asHtml)
  if (!answers?.length) throw new Error('Bad Assumption')
  if (answers.find((a) => goTogetherRegex.test(a.description))) {
    // This is found as an item in a question list, we need to first split the
    // questions and then  parse this question
    return
  }
  return answers
}

function getGridAnswers(asHtml: Document) {
  const grid = asHtml.getElementsByClassName('imgrid').item(0)
  if (!grid) return
  grid.remove()
  return Array.from(grid.getElementsByClassName('g--column'))
    .filter((item) => {
      return item.innerHTML.replace('<p></p>', '').trim()
    })
    .map((col) => {
      return {
        description: col.outerHTML,
        correct: false,
      }
    })
}

function getTableAnswers(asHtml: Document) {
  const table = asHtml.getElementsByTagName('ol').item(0)
  if (!table) return
  table.remove()
  return Array.from(table.getElementsByTagName('li')).map((li) => {
    return {
      description: li.innerHTML,
      correct: false,
    }
  })
}
